import { Form, Button, Input, Switch, Row, Col } from 'antd';
import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Loader } from '../../../../components/Loader';
import { PageHeader } from '../../../../components/PageHeader';

import { companyActions } from '../../../../redux/company/actions';

import { required } from '../../../../constants/validation';

import { useCompanyData } from './useCompanyData';

import { MyCompanyEditActionButtons } from './style';

import { Typography } from 'antd';
const { Text } = Typography;

export const MyCompanyEdit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { companyData, loading, saving } = useCompanyData();
  const { TextArea } = Input;

  useLayoutEffect(() => {
    form.setFieldsValue(companyData);
    return () => form.resetFields();
  }, [form, companyData]);

  const submitFinish = values => {
    dispatch(companyActions.updateCompany(companyData._id, values));
  };

  return (
    <>
      <PageHeader titleTranslationKey='myCompanies.editMyCompanyTitle' onBack={() => navigate('/front/my-companies')} />
      <Loader loading={loading}>
        {companyData ? (
          <Form
            name='myCompanyEdit'
            form={form}
            layout='vertical'
            // requiredMark='optional'
            scrollToFirstError={true}
            onFinish={submitFinish}
          >
            <Row>
              <Col span={11}>
                {companyData.wcoxmlweb_enabled ? <Text type='danger'>Wyłączenie możliwe tylko przez admina</Text> : <></>}
                <Form.Item name='wcoxmlweb_enabled' label={t('myCompanies.wcoxmlweb_enabled')} valuePropName='checked'>
                  <Switch checked={companyData.wcoxmlweb_enabled} disabled={true} />
                </Form.Item>
                {companyData.wcoxmlweb_enabled ? <Text type='danger'>Wyłączenie możliwe tylko przez admina</Text> : <></>}
                <Form.Item name='is_enabled' label={t('myCompanies.lisining')} valuePropName='checked'>
                  <Switch checked={companyData.is_enabled} disabled={companyData.wcoxmlweb_enabled} />
                </Form.Item>
                <Form.Item name='name' label={t('myCompanies.name')} {...required}>
                  <Input autoComplete='off' />
                </Form.Item>
                <Form.Item name='tax_id' label={t('myCompanies.tax_id')} {...required}>
                  <Input autoComplete='off' />
                </Form.Item>
                <Form.Item name='alerts_email' label={t('myCompanies.alertEmails')}>
                  <Input autoComplete='off' />
                </Form.Item>
                <Form.Item name='dhl_ids' label={t('myCompanies.dklNumbers')} {...required}>
                  <Input autoComplete='off' />
                </Form.Item>
              </Col>
              <Col span={11} push={1}>
                <Form.Item name='address' label={t('myCompanies.address')} {...required}>
                  <Input autoComplete='off' />
                </Form.Item>
                <Form.Item name='floor_name' label={t('myCompanies.floor_name')}>
                  <Input autoComplete='off' />
                </Form.Item>
                <Form.Item name='city' label={t('myCompanies.city')} {...required}>
                  <Input autoComplete='off' />
                </Form.Item>
                <Form.Item name='postal_code' label={t('myCompanies.postal_code')} {...required}>
                  <Input autoComplete='off' />
                </Form.Item>
                <Form.Item name='country' label={t('myCompanies.country')} {...required}>
                  <Input autoComplete='off' />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={11}>
                <Form.Item name='traderName' label={t('myCompanies.trader')}>
                  <Input autoComplete='off' disabled />
                </Form.Item>
              </Col>
              <Col span={12} push={1}>
                <Form.Item name='traderEmail' label={t('myCompanies.email')}>
                  <Input autoComplete='off' disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={22} push={1}>
                <Form.Item name='trader_notes' label={t('myCompanies.note')}>
                  <TextArea rows={4} placeholder='maxLength is 300' maxLength={300} />
                </Form.Item>
              </Col>
            </Row>
            <MyCompanyEditActionButtons>
              <Button onClick={() => navigate('/front/my-companies')}>{t('global.cancel')}</Button>
              <Button type='primary' htmlType='submit' loading={saving}>
                {t('global.save')}
              </Button>
            </MyCompanyEditActionButtons>
          </Form>
        ) : null}
      </Loader>
    </>
  );
};
